import React from 'react';
import { SvgIcon } from '@mui/material';

export function VkLogo(props) {
  return (
    <SvgIcon
      sx={{ width: '200px', height: '64px', viewBox: '0 0 200px 64px' }}
      {...props}
      viewBox="0 0 200 64"
      fill="none"
    >
      <svg
        width="200"
        height="64"
        viewBox="0 0 200 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11733_38814)">
          <path
            d="M68.9492 30.5783C68.9492 16.5265 68.9492 9.50066 73.3145 5.13534C77.6799 0.77002 84.7057 0.77002 98.7575 0.77002H101.242C115.293 0.77002 122.319 0.77002 126.685 5.13534C131.05 9.50066 131.05 16.5265 131.05 30.5783V33.0623C131.05 47.1141 131.05 54.1399 126.685 58.5053C122.319 62.8706 115.293 62.8706 101.242 62.8706H98.7575C84.7057 62.8706 77.6799 62.8706 73.3145 58.5053C68.9492 54.1399 68.9492 47.1141 68.9492 33.0623V30.5783Z"
            fill="#0077FF"
          />
          <path
            d="M101.993 45.5086C87.839 45.5086 79.7661 35.8053 79.4297 19.6592H86.5195C86.7524 31.51 91.9791 36.5298 96.1191 37.5648V19.6592H102.795V29.8799C106.883 29.44 111.178 24.7825 112.627 19.6592H119.303C118.191 25.9727 113.533 30.6303 110.221 32.5451C113.533 34.0976 118.838 38.16 120.856 45.5086H113.507C111.929 40.5923 107.996 36.7886 102.795 36.2711V45.5086H101.993Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_11733_38814">
            <rect
              width="62.1006"
              height="62.1006"
              fill="white"
              transform="translate(68.9492 0.77002)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
